import React from 'react';
import {getLoginUrl} from '../../shared/okta.helper'

export const unauthenticated = () => <h1 className="center-message"><span>Not logged in.</span>&nbsp;
    <a id="MEDCAL_RX_CLICK_HERE" href={getLoginUrl()}>
        Log in
    </a> <span>to the Medi-Cal Rx Provider Portal.</span></h1>;

export const unauthorized = () => <h1 className="center-message">You are not authorized to view this application.</h1>;
